import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'jalali-moment';
import { Skeleton } from 'primereact/skeleton';

import { AttachFileCreate, AttachFileDelete, AttachFileUpdate, baseUrl, SearchHire } from '../../utils/api';

import useToastNotification from '../../hooks/useToastNotification';
import Loader from '../loader/loader'


function Banner() {
    const { showError, showSuccess } = useToastNotification();

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const loadContactUs = async (page = pageIndex, size = pageSize) => {
        try {
            let response = await SearchHire({
                pageIndex: page,
                pageSize: size,
            });
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);

        } catch (error) {
            showError("خطا در بارگذاری اطلاعات");
        }
    };
    useEffect(() => {
        loadContactUs();
    }, [pageIndex, pageSize]);

    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };

    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);

        // Trigger a data fetch for the new page
        loadContactUs(event.page, event.rows);
    };

    // تبدیل تاریخ میلادی به شمسی
    const formatJalaliDate = (date) => {
        return moment(date).locale('fa').format('YYYY/MM/DD');
    };

    // بدنه سفارشی برای ستون تاریخ
    const dateBodyTemplate = (rowData) => {
        return formatJalaliDate(rowData.createDate);
    };

    return (
        <>
            {/* <div className="w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border">
            </div> */}
            <div>
                <DataTable
                        value={items}
                        size="small"
                        paginator
                        rows={pageSize}
                        totalRecords={totalRecords}
                        lazy
                        onPage={handlePagination}
                        first={(pageIndex - 1) * pageSize} // Current first record index
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        tableStyle={{ minWidth: '50rem' }}
                >
                    <Column field="id" header="ردیف" style={{ width: '5%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="departmentTitle" header="دپارتمان" style={{ width: '10%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="subjectTitle" header="موضوع" style={{ width: '30px', overflow: 'hidden', textOverflow: 'ellipsis' }} body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="fullName" header="نام و نام خانوادگی" style={{ width: '15%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="phoneNumber" header="شماره تماس" style={{ width: '10%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column
                        field="message"
                        header="متن پیام"
                        style={{
                            width: '100px',
                          
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    ></Column>
                    <Column field="createDate" header="تاریخ ثبت" body={dateBodyTemplate} style={{ width: '10%' }}></Column>
                </DataTable>

            </div>
        </>
    );
}

export default Banner;
